import { motion } from "framer-motion";

import {
    ShieldCheck,
    Headset,
    BadgeDollarSign,
    Truck
} from "lucide-react";


const reasons = [

    {
        title: "Quality Products",
        description:
            "Carefully selected healthcare equipment that meets customer needs.",
        icon: ShieldCheck
    },


    {
        title: "Reliable Support",
        description:
            "Professional guidance to help you choose the right equipment.",
        icon: Headset
    },


    {
        title: "Affordable Solutions",
        description:
            "Quality healthcare products at competitive prices.",
        icon: BadgeDollarSign
    },


    {
        title: "Fast Delivery",
        description:
            "Convenient delivery options for homes and healthcare facilities.",
        icon: Truck
    }

];



const WhyChooseSection = () => {


    return (

        <section className="
py-20
bg-green-100
">


            <div className="
max-w-7xl
mx-auto
px-6
">


                {/* Heading */}

                <motion.div

                    initial={{
                        opacity: 0,
                        y: 30
                    }}

                    whileInView={{
                        opacity: 1,
                        y: 0
                    }}

                    transition={{
                        duration: 0.6
                    }}

                    viewport={{
                        once: true
                    }}

                    className="
text-center
max-w-2xl
mx-auto
mb-12
"

                >

                    <h2 className="
text-3xl
md:text-4xl
font-bold
text-gray-900
">

                        Why Choose AfyaEquip?

                    </h2>


                    <p className="
mt-4
text-gray-600
">

                        Trusted healthcare solutions designed
                        around quality, care, and reliability.

                    </p>


                </motion.div>





                {/* Cards */}

                <div className="
grid
grid-cols-1
sm:grid-cols-2
lg:grid-cols-4
gap-6
">


                    {
                        reasons.map((item, index) => {


                            const Icon = item.icon;


                            return (

                                <motion.div

                                    key={index}

                                    initial={{
                                        opacity: 0,
                                        y: 40
                                    }}

                                    whileInView={{
                                        opacity: 1,
                                        y: 0
                                    }}

                                    transition={{
                                        duration: 0.5,
                                        delay: index * 0.1
                                    }}

                                    viewport={{
                                        once: true
                                    }}

                                    className="
border-4
border-white
rounded-2xl
p-6
text-center
hover:border
hover:border-green-600
hover:bg-white/50
hover:shadow-lg
transition-all
duration-300
"

                                >


                                    <div className="
mx-auto
w-16
h-16
rounded-full
bg-transparent
flex
items-center
justify-center
mb-5
">


                                        <Icon

                                            size={32}

                                            className="
text-green-600
"

                                        />


                                    </div>



                                    <h3 className="
text-lg
font-semibold
text-gray-900
">

                                        {item.title}

                                    </h3>



                                    <p className="
mt-3
text-sm
text-gray-600
leading-relaxed
">

                                        {item.description}

                                    </p>



                                </motion.div>

                            )

                        })

                    }


                </div>


            </div>


        </section>

    )

}


export default WhyChooseSection;